export enum Page {
  LOG_IN = '/log-in',
  DASHBOARD = '/dashboard',
}
